import { Link, useLocation } from 'react-router-dom';

export default function Sidebar() {
  const location = useLocation();

  const menuItems = [
    { path: '/', icon: 'ri-dashboard-line', label: '工作台' },
    { path: '/entry', icon: 'ri-edit-line', label: '快速录入' },
    { path: '/ledger', icon: 'ri-file-list-3-line', label: '台账查询' },
    { path: '/reports', icon: 'ri-bar-chart-box-line', label: '报表中心' },
    { path: '/finance', icon: 'ri-money-cny-circle-line', label: '财务管理' },
    { path: '/submission', icon: 'ri-send-plane-line', label: '数据报送' },
    { path: '/customers', icon: 'ri-team-line', label: '客户管理' },
    { path: '/settings', icon: 'ri-settings-3-line', label: '系统设置' }
  ];

  return (
    <div className="fixed left-0 top-0 h-screen w-64 bg-gradient-to-b from-[#0c7362] to-[#085b4d] flex flex-col shadow-strong">
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center">
            <i className="ri-plant-line text-2xl text-white"></i>
          </div>
          <div>
            <h1 className="text-lg font-bold text-white">粮食台账管理</h1>
            <p className="text-xs text-white/60">V1.0</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 overflow-y-auto">
        <ul className="space-y-2">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-xl transition-all duration-300 whitespace-nowrap group cursor-pointer ${
                    isActive
                      ? 'bg-white/20 text-white font-medium shadow-glow backdrop-blur-sm'
                      : 'text-white/70 hover:bg-white/10 hover:text-white hover:translate-x-1'
                  }`}
                >
                  <i className={`${item.icon} text-xl transition-transform duration-300 ${isActive ? 'scale-110' : 'group-hover:scale-110'}`}></i>
                  <span className="text-sm">{item.label}</span>
                  {isActive && (
                    <div className="ml-auto w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="p-4 border-t border-white/10">
        <div className="flex items-center space-x-3 px-4 py-3 bg-white/5 rounded-xl backdrop-blur-sm">
          <div className="w-10 h-10 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center shadow-medium">
            <i className="ri-user-line text-white text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-sm font-medium text-white">管理员</p>
            <p className="text-xs text-white/60">admin@grain.com</p>
          </div>
          <button 
            className="w-8 h-8 flex items-center justify-center hover:bg-white/10 rounded-lg transition-colors cursor-pointer"
            title="退出登录"
          >
            <i className="ri-logout-box-line text-white/70 hover:text-white text-lg"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
